import { GetAttachmentsPersistanceData } from './GetAttachmentsMapper.types'

class GetAttachmentsMapper {
  toDomain(persistenceData: GetAttachmentsPersistanceData) {
    return {
      fileInfo: persistenceData?.anexos?.map(attachment => {
        return {
          fileId: attachment?.idAnexo,
          fileName: attachment?.legenda,
          fileSize: `${attachment?.tamanho} KB`,
        }
      }),
    }
  }
}

export default new GetAttachmentsMapper()
